import React, { useEffect, useState } from "react";
import { Paper, Toolbar, Typography } from "@mui/material";
import MUIDataTable from "mui-datatables";
import AppConstants from '../../Constants/Constants';

function Datatable(props) {
  const [user, setUser] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    let token = localStorage.getItem('token')
    console.log("tokeeeeeee", token)
    // if (token) {
      console.log(token, "tokeeee")
      const getData = async () => {
        const url = `${AppConstants.backendURL}/user-management/user-subscriptions`
        try {
          const response = await fetch(url, {
            method: 'GET',
            headers: {
              Authorization: `Bearer ${token}`,
            },
          });
          console.log(response, "forresponse");
          if (response.statusText === 'OK') {
            const data = await response.json();
            console.log(data, "For data");
            setUser(data);
          } else {
            throw new Error('Request failed')
          }
        } catch (error) {
          console.log(error, "errrrrrrr");
        }
      };
      getData();
    // }

  }, []);

  const options = {
    elevation: 0,
    filterType: "multiselect",
    selectableRows: "none",
    selectableRowsHeader: false,
    download: false,
    print: false,
    searchPlaceholder: "Enter search key",
    searchAlwaysOpen: true
  };
  const columns = [
    {
      name: "uid",
      label: "uid",
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: "name",
      label: "name",
      options: {
        filter: true,
        sort: false,
      },
    },
    {
      name: "email",
      label: "email",
      options: {
        filter: true,
        sort: false,
      },
    },
    {
      name: "sub_names",
      label: "sub_names",
      options: {
        filter: true,
        sort: false,
      },
    },
    {
      name: "total_cost",
      label: "total_cost",
      options: {
        filter: true,
        sort: false,
      },
    },
  ];
  return (
    <>
      <Paper
        elevation={3}
        sx={{
          width: "80%",
          float: "right",
          marginRight: "20px",
          marginTop: "80px",
        }}
      >
        <Toolbar
          mt={3}
          sx={{
            padding: "1.2rem",
            borderBottom: "4px solid var(--primary-color)",
          }}
        >
          <Typography
            sx={{
              flex: "1 1 100%",
              color: "var(--primary-color)",
              fontWeight: "bold",
            }}
            variant="h5"
            id="tableTitle"
          >
            All Users Subscriptions
          </Typography>
        </Toolbar>
        <MUIDataTable
          className="m-3"
          data={user}
          columns={columns}
          options={options}
        />
      </Paper>
    </>
  );
}

export default Datatable;